var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nio-address-list',{ref:"nioAddressList",attrs:{"show":_vm.show,"clickOverlay":_vm.clickOverlay,"province":_vm.provinceData,"city":_vm.cityData,"tabList":[0, 1]},on:{"update:show":v => _vm.$emit('update:show', v),"selectAddress":_vm.handleSelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }